import { NzSafeAny } from 'ng-zorro-antd/core/types';

export interface AlainChartConfig {
  theme?: string | { [key: string]: NzSafeAny };
}
